export function traceObject(parameters: unknown): string {
    return JSON.stringify(parameters, undefined, 2)
}
